/*eslint no-console: 0*/
const  EventBus = window.VueEventBus
import config from '../../lib/config'
import PageMixins from '../../components/_mixins/pages'

export default {
  name: 'raceway-email-verification',
  settings: 'page.email-verification',
  translations: 'page.email-verification',
  props: [
    'token', 'email', 'successMessage', 'failureMessage'
  ],
  mixins: [PageMixins],

  data() {
    return {
      isSubmitting: false,
    }
  },
  mounted() {

  },
  created() {
    // window.skipGlobalTimerMessage = true
    this.query = this.$route.query
    // EventBus.$emit('email-verification.failed', e, this.email)
    EventBus.$on('email-verification.init', () => {
      this.isSubmitting = true
    })
    EventBus.$on('email-verification.end', () => {
      this.isSubmitting = false
    })
  },
  computed: {

  },
  methods: {

  }
}
